import { cn } from "@/lib/cn";

export function buildDatatableToolbarRowClass(noInset: boolean): string {
  return cn(
    "no-scrollbar max-w-screen chrome-row relative flex shrink-0 items-center justify-between gap-2 overflow-x-scroll border-b border-solid text-sm",
    noInset ? "px-1" : "px-[var(--chrome-gutter)]",
  );
}
